import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { mapPromise } from '@rad/utility/promise';
import { useFetch, useLocalStorage } from '@rad/hooks';
import { useNotify } from '@rad/contexts/notifications';
import { getScorecards } from '../types';
import { ScorecardTable } from '../components/tables/scorecards';
import LayoutRoot from '../layouts/root';
import ActionButton from '../components/action-button';
export const ScorecardsScreen = (props) => {
    const [token] = useLocalStorage('token');
    const notify = useNotify();
    const [dataPromise, dataReload] = useFetch(getScorecards());
    return _jsx(LayoutRoot, { toolbarRight: _jsx(_Fragment, { children: _jsx("a", { href: "#/scorecards/new", className: "btn btn-sm btn-primary", children: "Request New Scorecard" }) }), children: _jsx(ScorecardTable, { title: "My Scorecards", scorecards: mapPromise(dataPromise, (xs) => xs.filter((x) => x.owner === token?.user_id)), actions: (x) => _jsx(_Fragment, { children: x.is_build && _jsx(ActionButton, { href: `#/scorecards/${x.id}/edit`, style: "danger", icon: "pencil", title: "Edit" }) }) }) });
};
export default ScorecardsScreen;
